import React from "react";
import "../styles/GraduateTrainingDetails.scss";

const CookiesPolicyDetails = () => {
  return (
    <section className="space graduate-details">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-10 col-lg-11">
            <div className="graduate-card">
              <h2 className="graduate-main-title">Cookies Policy</h2>
              <p>
                <strong>Effective Date: January 1, 2026</strong>
              </p>

              <p>
                This Cookies Policy explains how cookies and similar technologies
                are used on our website and within our tender and affiliate
                systems (collectively, the &quot;Systems&quot;). By using the
                Systems, you consent to the use of cookies as described in this
                policy.
              </p>

              <h3 className="graduate-section-title">1. What Are Cookies?</h3>
              <p>
                Cookies are small text files that are placed on your computer or
                device when you visit our website. They are widely used to make
                websites work, or work more efficiently, as well as to provide
                information to the website owner.
              </p>

              <h3 className="graduate-section-title">2. How We Use Cookies</h3>
              <p>We use cookies for various purposes, including but not limited to:</p>
              <ul className="graduate-list">
                <li>
                  <strong>Essential Cookies:</strong> These cookies are
                  necessary for the operation of the Systems. They include, for
                  example, cookies that enable you to log into secure areas of
                  the Systems.
                </li>
                <li>
                  <strong>Analytical/Performance Cookies:</strong> These cookies
                  allow us to recognize and count the number of visitors and to
                  see how visitors move around our website. This helps us to
                  improve the way the Website functions and/or Systems work, for
                  example, by ensuring that users can find what they are looking
                  for easily.
                </li>
                <li>
                  <strong>Functionality Cookies:</strong> These cookies are used
                  to recognize you when you return to our website. This enables
                  us to personalize our content for you and remember your
                  preferences.
                </li>
              </ul>

              <h3 className="graduate-section-title">3. Third-Party Cookies</h3>
              <p>
                Some cookies used on our website are set by third-party
                companies and may include but are not limited to:
              </p>
              <ul className="graduate-list">
                <li>Analytical services (e.g., Google Analytics)</li>
                <li>Social media buttons</li>
                <li>Affiliate marketing partners</li>
                <li>
                  These third parties may use cookies in accordance with their
                  own privacy policies.
                </li>
              </ul>

              <h3 className="graduate-section-title">4. Cookie Control</h3>
              <p>
                You can control and manage cookies in various ways. Please note
                that removing or blocking cookies may affect your user
                experience and may prevent certain parts of the Website and/or
                Systems from working correctly.
              </p>

              <h3 className="graduate-section-title">5. Changes to Our Cookies Policy</h3>
              <p>
                We may update this Cookies Policy from time to time. Changes
                will be posted on this page with the &quot;Effective Date&quot;
                at the top.
              </p>

              <h3 className="graduate-section-title">6. Contact Information</h3>
              <p>
                If you have any questions about these Terms, please contact us
                using the form provided on the website{" "}
                <a
                  href="https://kiubunifu.com/contact"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://kiubunifu.com/contact
                </a>{" "}
                or email us at{" "}
                <a href="mailto:customerservice@kiubunifu.com">customerservice@kiubunifu.com</a>.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CookiesPolicyDetails;
